import { FleetReportsConstants } from "constants/constants";
import { initialFleetReportsState } from "store/initialStates";
import { FleetReportsState } from "types/FleetReports";
import { ReducersInterfaceAction } from "types/Reducers";

export const fleetReportsReducer = (
  state = initialFleetReportsState,
  action: ReducersInterfaceAction,
): FleetReportsState => {
  switch (action.type) {
    case FleetReportsConstants.FLEET_REPORTS_GET_DATA_SUCCESS:
      return {
        ...state,
        loadingData: false,
        fleetReportList: action.payload.dataList,
        offBoardedFleetReportList: action.payload.offBoardedDataList,
      };
    case FleetReportsConstants.FLEET_REPORTS_UPDATE_MULTIPLE_REPORTS:
      return {
        ...state,
        loadingData: false,
        fleetReportList: action.payload.dataList,
        offBoardedFleetReportList: action.payload.offBoardedDataList,
        selectedIdList: [],
      };
    case FleetReportsConstants.UPDATE_FLEET_REPORT_SUCCESS:
      return {
        ...state,
        loadingData: false,
        fleetReportList: action.payload.list,
        offBoardedFleetReportList: action.payload.offBoardedList,
      };
    case FleetReportsConstants.FLEET_REPORTS_LOADING:
      return {
        ...state,
        loadingData: true,
      };
    case FleetReportsConstants.FLEET_REPORTS_ERROR:
      return {
        ...state,
        loadingData: false,
      };
    case FleetReportsConstants.FLEET_REPORTS_SET_FILTERS:
      return { ...state, fleetReportFilters: {...state.fleetReportFilters, ...action.payload}, selectedIdList: [] };
    case FleetReportsConstants.FLEET_REPORTS_SET_SELECTED_VANS:
      return {
        ...state,
        selectedIdList: action.payload,
      };
    case FleetReportsConstants.FLEET_REPORTS_SET_STATUS_LIST_FILTER:
      return {
        ...state,
        fleetReportFilters: {
          ...state.fleetReportFilters,
          statuses: action.payload,
        },
      };
    default:
      return state;
  }
};
